"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApContextualPopup = void 0;
var React = require("react");
var ClickOutsideTooltip_1 = require("./ClickOutsideTooltip");
var styles_1 = require("./styles");
var ApContextualPopup = /** @class */ (function (_super) {
    __extends(ApContextualPopup, _super);
    function ApContextualPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            forceClose: false,
        };
        _this.tooltipRef = null;
        _this.handleClickOutside = function () {
            styles_1.StyledReactTooltip.hide(_this.tooltipRef);
        };
        _this.forceTooltipClose = function () {
            var tooltip = _this.props.tooltip;
            if (tooltip.afterHide) {
                tooltip.afterHide();
            }
            // Force tooltip close while mouse hover on itself
            _this.setState({ forceClose: true }, function () {
                return _this.setState({ forceClose: false });
            });
        };
        return _this;
    }
    ApContextualPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, trigger = _a.trigger, id = _a.id, tooltip = _a.tooltip;
        var forceClose = this.state.forceClose;
        var TriggerComponent = trigger();
        var triggerComponent = React.cloneElement(TriggerComponent, {
            className: (TriggerComponent.props.className ? TriggerComponent.props.className : '') + " ap-contextual-popup-trigger",
            'data-for': id,
            'data-tip': 'tooltip',
            ref: function (ref) { return (_this.tooltipRef = ref); },
        });
        return (React.createElement(React.Fragment, null,
            triggerComponent,
            !forceClose && (React.createElement(ClickOutsideTooltip_1.default, __assign({ handleClickOutside: this.handleClickOutside, className: "ap-contextual-popup " + (className ? className : ''), id: id, isCapture: true, place: "bottom", clickable: true, type: "light", effect: "solid", overridePosition: function (_a, currentEvent, currentTarget, node) {
                    var left = _a.left, top = _a.top;
                    var d = document.documentElement;
                    left = Math.min(d.clientWidth - node.clientWidth, left);
                    top = Math.min(d.clientHeight - node.clientHeight, top);
                    left = Math.max(0, left);
                    top = Math.max(0, top);
                    return { top: top, left: left };
                }, getContent: function () { return children({ close: _this.forceTooltipClose }); } }, tooltip)))));
    };
    ApContextualPopup.defaultProps = {
        tooltip: {},
    };
    return ApContextualPopup;
}(React.Component));
exports.ApContextualPopup = ApContextualPopup;
//# sourceMappingURL=ApContextualPopup.js.map